import './Stepper.css';
import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaCheck } from 'react-icons/fa';
import { TbProgress } from 'react-icons/tb';

const Stepper = ({activeStep}) => {
  const [currentStep, setCurrentStep] = useState(1);
  
  const steps = [
    { title: 'Bienvenido', name: 'welcome', value: 1 },
    { title: 'Datos de paciente', name: 'prospect-register', value: 2 },
    { title: 'Consentimiento', name: 'consent', value: 3 },
    { title: 'Finalizar', name: 'finish', value: 4 },
  ]

  useEffect(() => {
    const step = steps.find(step => step.name === activeStep);
    setCurrentStep(step.value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeStep]);

  const getStepClass = (step) => {
    if (step < currentStep) {
      return 'step completed';
    } else if (step === currentStep) {
      return 'step in-progress';
    } else {
      return 'step';
    }
  };

  return (
    <div className="container">
      <div 
        className="stepper" 
      >
        {steps.map((step, index) => (
          <div key={index} className={getStepClass(index + 1)}>
            <div className="step-icon">
              {index + 1 < currentStep || currentStep === 4 ? (
                <FaCheck />
              ) : index + 1 === currentStep ? (
                <TbProgress />
              ) : (
                index + 1
              )}
            </div>
            <div className="step-title">{step.title}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Stepper;